import React from "react";

export const TableHeadAll = ({ displayGridProps }) => {
  return (
    <React.Fragment>
      <thead className="sd_table_thead">
        <tr>
          <th className="total-pax" style={{ width: "25%" }}>
            <p className="font_16_r">
              Name /<br />
              Request Number
            </p>
          </th>
          <th
            className={displayGridProps ? "location-table" : "location"}
            style={{ width: "25%" }}
          >
            <p className="font_16_r">Total PAX</p>
          </th>

          <th className="date-time-timer" style={{ width: "25%" }}>
            <p className="font_16_r">Date / Time</p>
            {displayGridProps ? null : <p className="font_16_r">Timer</p>}
            {/* {displayGridProps ? null : <p className="font_10_r">(HH:MM:SS)</p>} */}
          </th>
          {displayGridProps ? null : (
            <th className="seating-preference" style={{ width: "25%" }}>
              <p className="font_16_r">
                Seating
                <br />
                Preference
              </p>
            </th>
          )}
        </tr>
      </thead>
    </React.Fragment>
  );
};
